import { Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import styles from "../../../assets/styles/componentStyles/chatbot.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import ChatbotPreviewSection from '../chatbot/chatbotPreviewSection';
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, homeBreadcrumb, tryChatbotBreadcrumb } from '../../../utils/breadcrumb';
import { useSearchParams } from 'react-router-dom';

interface propsViewChatbot {
    currentTab: string
}
const TryUserChatbot = ({ currentTab }: propsViewChatbot) => {
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1200px)')
    const [openSwipableDrawer, setOpenSwipableDrawer] = useState<boolean>(false)
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload 
    let pathname = window.location.pathname.toLowerCase();

    const [searchParams] = useSearchParams();
    const chatbot_id = searchParams.get('chatbot_id');

    const toggleDrawer = (newOpen: any) => () => {
        setOpenSwipableDrawer(newOpen);
    };

    const innerHeight = (window.innerHeight - 90);

    useEffect(() => {
        const updatedBreadcrumbs = [
            // ...((pathname != '/' && pathname != '/chatbot') ? [{...homeBreadcrumb, path: '/chatbot'}] : []), 
            {...homeBreadcrumb},
            AIChatbotBreadcrumb, 
            {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`},
            {...tryChatbotBreadcrumb, isActive: true}, 
        ]; 
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    return (
        <>
            <Grid container className={`${globalStyles.dashboardChildWrapper} ${styles.trydashboardStyle}`} sx={{ height: `${innerHeight}px !important`, maxHeight: `${innerHeight}px !important`, overflow: "auto" }} direction="column">
                <Grid item xs={12} className={`${styles.cbHeaderMainItem} ${globalStyles.fullHeight}`} sx={{ position: "relative" }}>
                    <Grid container

                        className={`${styles.container} ${globalStyles.fullHeight}`} direction={"column"} alignItems={"center"}>
                        <Grid item className={styles.fixGridContainer} xs={12}></Grid>
                        <Grid item xs={12} className={`${styles.tryChatbotDesign} ${globalStyles.fullHeight}`}>
                            <ChatbotPreviewSection
                                flagSmallScreen={flagSmallScreen}
                                setOpenSwipableDrawer={setOpenSwipableDrawer}
                                openSwipableDrawer={openSwipableDrawer}
                                toggleDrawer={toggleDrawer}
                                currentTab={currentTab}
                                flagTryIt={true}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default TryUserChatbot
